/** F0.3: teszt sorok kizárása aggregátumokból / listákból. */

export type WithTestFlag = { is_test?: boolean | null };

export function excludeTestData<T extends WithTestFlag>(rows: T[] | null | undefined): T[] {
  return (rows ?? []).filter((r) => r.is_test !== true);
}

export function isTestRow(row: WithTestFlag | null | undefined): boolean {
  return row?.is_test === true;
}

export const TEST_DATA_TABLES = [
  "phases",
  "tasks",
  "quotes",
  "expenses",
  "contacts",
  "documents",
  "bot_proposals"
] as const;

export type TestDataTable = (typeof TEST_DATA_TABLES)[number];

export const TEST_DATA_TABLE_LABEL: Record<TestDataTable, string> = {
  phases: "Fázisok",
  tasks: "Feladatok",
  quotes: "Árajánlatok",
  expenses: "Kiadások",
  contacts: "Kontaktok",
  documents: "Dokumentumok",
  bot_proposals: "Bot javaslatok"
};
